export default {

    /**
     * Get wsusers list
     * @param state
     * @returns {default.wsusers|{}}
     */
    list: state => (id) => {

        // Return tasks list
        return Object.values(state.wsusers).filter((ut) => (!ut.deleted_at && ut.workspace_id == id));
    },

    /**
     * Get workspaces
     * @param state
     * @returns {default.wsusers|{}}
     */
    workspacesList: state => (user_id) => {

        // Return tasks list
        return Object.values(state.wsusers).filter((ut) => (!ut.deleted_at && ut.user_id == user_id));
    },

    /**
     * Get wsuser by id
     * @param state
     * @returns {default.wsusers|{}}
     */
    getByID: state => (id) => {
        // Return wsuser list
        return state.wsusers[id];
    },

    /**
     * Get wsuser by user id
     * @param state
     * @returns {default.wsusers|{}}
     */
    getByUserId: state => (id, all = false) => {
        // Find user
        const us = Object.values(state.wsusers).filter(ws => ws.user_id == id);
        if (!all) {
            // Return wsuser list
            return us ? us[0] : us;
        }
        return us;
    },

}
